"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function CookieCategoriesConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="w-full">
            <AspectRatio ratio={1 / 1.5}>
              <div className="h-full w-full animate-pulse rounded-none bg-muted/20" />
            </AspectRatio>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[400px] items-center justify-center text-center">
        <p className="text-muted-foreground font-sans">
          Unable to load research categories at this time.
        </p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6 lg:gap-8">
      {terms.map((term, i) => <div key={term.id} data-index={i} className="w-full">
          <Link to={term.link || "/ShopPage"} className="group relative block h-full w-full overflow-hidden rounded-none border border-transparent transition-colors duration-500 hover:border-primary/50">
            <AspectRatio ratio={1 / 1.5}>
              <img src={term.image_url || `/img/research_category_${i + 1}.png`} alt={term.name} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-background/60 transition-colors duration-700 ease-in-out group-hover:bg-background/40" />
              
              {}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                <h3 className="font-default text-3xl font-bold tracking-tighter text-foreground md:text-4xl lg:text-5xl uppercase">
                  {term.name}
                </h3>
                
                <div className="mt-6 overflow-hidden">
                  <span className="block translate-y-[120%] font-mono text-xs font-medium tracking-[0.3em] text-primary opacity-0 transition-all duration-500 ease-out uppercase group-hover:translate-y-0 group-hover:opacity-100">
                    View Specifications →
                  </span>
                </div>
              </div>

              {}
              <div className="absolute bottom-6 right-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" className="text-primary">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </AspectRatio>
          </Link>
        </div>)}
    </div>;
}
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
export default function TheCookieCategories() {
  return <section data-section-id="223546" id="research-categories" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-4xl font-bold text-foreground md:text-5xl lg:text-6xl tracking-tighter uppercase">
            Research Categories
          </h2>
          <div className="mx-auto mt-6 h-px w-24 bg-primary" />
          <p className="mt-8 font-sans text-sm tracking-widest text-muted-foreground uppercase">
            Ultra-Pure Compounds for Laboratory Analysis
          </p>
        </div>
        
        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <CookieCategoriesConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}